import React from 'react';
export function LoginSidebar() {
  return <aside className="space-y-4" data-id="element-31">
      <div className="bg-white border border-gray-300" data-id="element-32">
        <div className="bg-red-900 text-white px-4 py-2 font-semibold" data-id="element-33">
          MEMBER LOGIN
        </div>
        <div className="p-4 space-y-4" data-id="element-34">
          <a href="#" className="text-blue-700 text-sm hover:underline" data-id="element-35">
            New members sign up here
          </a>
          <p className="text-sm text-gray-700" data-id="element-36">Existing members log in here.</p>

          <div data-id="element-37">
            <label htmlFor="email" className="block text-sm font-semibold text-gray-800 mb-1" data-id="element-38">
              Email
            </label>
            <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300" data-id="element-39" />
          </div>

          <div data-id="element-40">
            <label htmlFor="password" className="block text-sm font-semibold text-gray-800 mb-1" data-id="element-41">
              Password
            </label>
            <input type="password" id="password" className="w-full px-3 py-2 border border-gray-300" data-id="element-42" />
          </div>

          <div className="flex gap-2" data-id="element-43">
            <button className="flex-1 bg-blue-700 text-white px-4 py-2 font-semibold hover:bg-blue-800" data-id="element-44">
              Log In
            </button>
            <button className="flex-1 bg-blue-700 text-white px-4 py-2 font-semibold hover:bg-blue-800" data-id="element-45">
              Find Pass
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white border border-gray-300" data-id="element-46">
        <div className="bg-red-900 text-white px-4 py-2 font-semibold" data-id="element-47">
          Announcements
        </div>
        <div className="p-4 min-h-[100px] bg-gray-50" data-id="element-48">
          {/* Empty announcements area */}
        </div>
      </div>
    </aside>;
}